import React, { useEffect } from "react";
import { useProductData } from "./zustand/productStore.js";
import { useTemplateStore } from "./zustand/templateStore.js";
import { useMarketingStore } from "./zustand/emailMarketingStore.js";
import Bars from "./components/Bars.jsx";
import Overlay from "./components/misc/overlay.jsx";
import Header from "./components/header";
import { Form } from "./components/forms/Form.jsx";
import BenefitsListV2 from "./components/BenefitsListV2";
import TestimonialsList from "./components/testimonials/TestimonialsList";
import SimpleFooter from "./components/simpleFooter";
import MobileSectionSeperator from "./components/mobileComponents/MobileSectionSeperator";
import UpsellPopupOverlay from "./components/popups/upsellPopupOverlay.jsx";
import VariantsPickerSeparate from "./components/ProductPackages/VariantsPickerSeparate";
import ProductPackages from "./components/ProductPackages/ProductPackages";
import ProductHeroSection from "./components/ProductHeroContainer/ProductHeroSection";
import TopbarOffer from "./components/TopbarOffer";
import OrderOverviewDrawerV3 from "./components/orderSummary/OrderOverviewDrawerV3.jsx";
import FreeShippingPopup from "./components/popups/FreeShippingPopup.jsx";
import UpsellPopup from "./components/popups/UpsellPopup.jsx";

const Layout = () => {
  const {
    isLoading,
    paymentMethod,
    upsellPopup,
    setLoadingState,
    withProductPicker,
    complianceDesktop,
    complianceMobile,
    isMobile,
    direct,
    setIsMobile,
    mobileGallery,
    setIsMobileGallery,
  } = useTemplateStore();
  const { freeShippingApplied, freeShippingEnabled } = useMarketingStore();
  const productData = useProductData();
  const base = window.post_template;
  const isDefaultHeroLayout =
    window?.post_template?.checkout_v4_product_hero?.checkout_v4_product_hero_variant == "default";

  const complianceMode = (isMobile == false && complianceDesktop) || (isMobile == true && complianceMobile);

  const newPicker = productData?.show_product_picker_v2;

  useEffect(() => {
    const encodedAffParam = new URL(location).searchParams.get("aff");
    const decodedAffParam = atob(encodedAffParam);

    if (window?.postId) {
      productData.get({
        postId: window.postId,
        isMobile: isMobile,
        affParam: decodedAffParam,
      });
    }
  }, [isMobile]);

  useEffect(() => {
    function updateIsMobile() {
      setIsMobile(window.innerWidth <= 767);
      setIsMobileGallery(window.innerWidth < 1072);
    }

    window.addEventListener("resize", updateIsMobile);
    updateIsMobile();
    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  useEffect(() => {
    const handlePageHide = () => {
      setLoadingState(false);
    };

    window.addEventListener("pagehide", handlePageHide);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);

  const enableVariants = productData?.enable_color_variants || productData?.enable_size_variants;

  return (
    <>
      {base.checkout_v4_topbar?.checkout_v4_topbar_show && <TopbarOffer />}
      <Header />
      {base.checkout_v4_product_hero.checkout_v4_product_hero_show && <ProductHeroSection isMobile={mobileGallery} />}
      <main className="main" data-cy="cc-v4">
        <div className="main_leftSide"></div>
        <section className="contentContainer">
          <article
            className={`productContainer
                     ${base.checkout_v4_meta_bars.checkout_v4_meta_bars_show || "v2"}
                     `}
          >
            {!newPicker
              ? !isMobile && base.checkout_v4_meta_bars.checkout_v4_meta_bars_show && <Bars />
              : base.checkout_v4_meta_bars.checkout_v4_meta_bars_show && <Bars />}
            {(base.checkout_v4_meta_bars.checkout_v4_meta_bars_show ||
              base.checkout_v4_product_hero.checkout_v4_product_hero_show) &&
            withProductPicker &&
            !isDefaultHeroLayout ? (
              <MobileSectionSeperator border="" margin="0px 16px 0px -16px" />
            ) : (
              ""
            )}
            {isMobile &&
              window?.post_template.checkout_v4_product_hero.checkout_v4_product_hero_variant == "oneBar" && (
                <Bars mobile={true} onlyProgress={true}></Bars>
              )}
            {productData?.variants_picker_type == "separate" && enableVariants && (
              <>
                <VariantsPickerSeparate />
                <MobileSectionSeperator margin="0px 0px 0px -16px" />
              </>
            )}
            {withProductPicker && <ProductPackages />}
            {base.checkout_v4_meta_bars.checkout_v4_meta_bars_show ||
            base.checkout_v4_product_hero.checkout_v4_product_hero_show ? (
              <MobileSectionSeperator margin="0px 0px 24px -16px" />
            ) : (
              ""
            )}
            <Form />
            {!isMobile && <SimpleFooter />}
          </article>
          <div className="summaryContainer v2">
            {<OrderOverviewDrawerV3 />}
            <BenefitsListV2 />
            {!complianceMode && <TestimonialsList />}
          </div>
          {isMobile && <SimpleFooter />}
        </section>
        <div className="main_rightSide"></div>
      </main>

      {((upsellPopup?.popupClicked && !upsellPopup?.popupClicked) || isLoading) && (
        <Overlay loading={isLoading} paymentMethod={paymentMethod} />
      )}
      {upsellPopup?.displayPopup && (
        <UpsellPopupOverlay>
          <UpsellPopup />
        </UpsellPopupOverlay>
      )}
      {freeShippingApplied && freeShippingEnabled && <FreeShippingPopup />}
    </>
  );
};

export { Layout };
